import { FC } from "react";

import { Grid } from "@mui/material";
import { useForm } from "react-hook-form";

import { AmplitudeEvents } from "../../../../../common/constants/amplitude";
import { useTranslate } from "../../../../../common/hooks/useTranslate";
import { FaqAccordion } from "../../../../components/Accordion/FaqAccordion";
import { useLiveFormAmplitudeEvents } from "../../common/amplitude/useLiveFormAmplitudeEvents";
import { useLiveFormEditorContext } from "../../common/LiveFormEditorContext";
import { FormStepContainer } from "../FormStepContainer";

import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";

export const LiveEditorStepBusinessModel: FC = () => {
  const { t } = useTranslate();

  const { goToNextStep, goToPreviousStep } = useLiveFormEditorContext();
  const { logUserActionEvent } = useLiveFormAmplitudeEvents();

  const questions = (["willIHaveToPay", "howZeffyMakesMoney", "whatIfDonorsDoNotTip"] as const).map((prefix) => ({
    title: (
      <DashboardTypography variant="subtitle1" vibe="text-neutral-moderate">
        {t("dashboard", `liveFormEditor.businessModelStep.${prefix}.title`)}
      </DashboardTypography>
    ),
    content: (
      <DashboardTypography variant="body2" vibe="text-neutral-moderate">
        {t("dashboard", `liveFormEditor.businessModelStep.${prefix}.content`)}
      </DashboardTypography>
    ),
  }));

  // We use a dummy form to make the step container work despite the fact that the business model step is not a form
  const form = useForm();
  return (
    <FormStepContainer
      title={t("dashboard", "editor.stepBusinessModel.title")}
      description={t("dashboard", "editor.stepBusinessModel.description")}
      form={form}
      actionsProps={{
        onBack: () => {
          logUserActionEvent(AmplitudeEvents.FormBackButtonClicked);
          goToPreviousStep();
        },
        onNext: () => {
          logUserActionEvent(AmplitudeEvents.FormStepSubmitted);
          goToNextStep();
        },
        nextButtonLabel: "next",
      }}
    >
      <Grid container spacing={2} paddingTop={2}>
        <Grid item xs={12}>
          <FaqAccordion steps={questions} />
        </Grid>
      </Grid>
    </FormStepContainer>
  );
};
